// extracted by mini-css-extract-plugin
export default {"container":"Gallery_container__Gzeo+","info":"Gallery_info__JRGCC","imgs":"Gallery_imgs__alIJZ"};